async function waitForFollowerRefresh(start, status, { cancelled = () => false, wait = ms => new Promise(resolve => setTimeout(resolve, ms)), jitter = () => Math.floor(Math.random() * 1000), attempts = 12 } = {}) {
  async function request(fn) {
    for (let retry = 0; ; retry++) {
      if (cancelled()) throw new Error('Follower refresh cancelled.');
      try { return await fn(); }
      catch (error) {
        if (error.status !== 429 || retry >= 1) throw error;
        await wait(Math.max(30000, (error.retryAfter || 0) * 1000) + jitter());
      }
    }
  }
  const initial = await request(start);
  if ('available' in initial) return initial; // previous backend during rolling deployments
  for (let attempt = 0; attempt < attempts; attempt++) {
    if (cancelled()) throw new Error('Follower refresh cancelled.');
    const state = await request(status);
    if (!state.pending) {
      if (state.result) return state.result;
      throw new Error(state.error || 'Follower insights are temporarily unavailable.');
    }
    await wait(10000 + jitter());
  }
  throw new Error('Follower insights are still updating in the background. Please check again shortly.');
}
module.exports = { waitForFollowerRefresh };
